<template>
  <div>test</div>
</template>
<script>
export default {
  mounted() {
    const phone_number = "+82 10-6740-3230";
    console.log("", this.$helper.makePhoneNumber(phone_number));
  },
  methods: {},
};
</script>
<style lang="">
</style>